import axios from 'axios'

export default {
    get () {
        return axios.get('/api/user');
    },
    index (resellerId) {
        return axios.get(`/api/resellers/${resellerId}/users`)
    },
    store (resellerId, data) {
        return axios.post(`/api/resellers/${resellerId}/users`, data)
    },
    update (userId, data) {
        return axios.put(`/api/users/${userId}`, data)
    },
    changePassword (data) {
        return axios.post(`/api/users/changepassword`, data)
    },
    delete (userId) {
        return axios.delete(`/api/users/${userId}`)
    },
    sendRegistrationMail (userId) {
        return axios.post(`/api/users/${userId}/registration`)
    }
}